// Kept free of imports: the edit invoice modal reads these, and the modal conductor loads that modal
// from util.js's own import graph, so anything heavier here closes an import cycle.

const ACCOUNTING_ID_KEYS = ['quickbooksId', 'xeroId', 'economicId', 'sageIntacctId'];

/**
 * An invoice imported from Xero is linked (it has a xeroId) but is not an exported
 * invoice. isImported comes from GraphQL (flag, marker and link already checked there);
 * isExported is "linked to an accounting system and not imported".
 */
export const getInvoiceLinkState = (invoice, idKeys = ACCOUNTING_ID_KEYS) => {
	const isImported = !!invoice.isImported;
	const isLinked = idKeys.some(key => !!invoice[key]);
	return {isImported, isExported: !isImported && isLinked};
};

/**
 * The status dropdown and Xero status column of an invoice table row. An imported invoice shows
 * Imported in a disabled dropdown with its Xero status beside it, as an exported one shows Exported.
 */
export const getInvoiceStatusCell = ({status, isImported, isExported}) => ({
	disabled: isExported || isImported,
	selectedItems: isImported ? ['IMPORTED'] : isExported ? 'EXPORTED' : [status],
	showImportedOption: isImported,
	showExternalStatus: isExported || isImported,
});

/** Whether an invoice counts in the project's sent-or-exported card. An imported invoice always does. */
export const isSentOrExportedInvoice = invoice =>
	invoice.status === 'SENT' || invoice.status === 'EXPORTED' || !!invoice.isImported;
